// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qr-caption {
  text-align: right;
}

.inventory-check-btn {
  padding: 8px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.deicing .card-body-content {
  width: 100%;
  max-width: 1800px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.deicing-list .item-list-toolbar-right {
  margin-top: 0;
}

.deicing-list .item-list-toolbar {
  align-items: center;
}

.deicing-list .card {
  height: 100dvh;
}

.deicing-list .card-header,
.deicing-list .item-list-toolbar {
  flex-shrink: 0;
}

.deicing-list .card-body {
  overflow: hidden;
  padding-bottom: 88px;
}

.deicing-list .card-body-content {
  min-height: 0;
}

.deicing-list .item-list-card {
  flex: 1;
  min-height: 0;
  height: auto;
  margin-bottom: 0;
}

.deicing-list .item-list-grid-wrapper {
  flex: 1;
  min-height: 0;
  height: auto;
}

.deicing-list .item-list-actions {
  margin-top: 0;
}
`, "",{"version":3,"sources":["webpack://./src/web/component/ItemListCard/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;AACf","sourcesContent":[".qr-caption {\r\n  text-align: right;\r\n}\r\n\r\n.inventory-check-btn {\r\n  padding: 8px;\r\n  border-radius: 4px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.deicing .card-body-content {\r\n  width: 100%;\r\n  max-width: 1800px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.deicing-list .item-list-toolbar-right {\r\n  margin-top: 0;\r\n}\r\n\r\n.deicing-list .item-list-toolbar {\r\n  align-items: center;\r\n}\r\n\r\n.deicing-list .card {\r\n  height: 100dvh;\r\n}\r\n\r\n.deicing-list .card-header,\r\n.deicing-list .item-list-toolbar {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.deicing-list .card-body {\r\n  overflow: hidden;\r\n  padding-bottom: 88px;\r\n}\r\n\r\n.deicing-list .card-body-content {\r\n  min-height: 0;\r\n}\r\n\r\n.deicing-list .item-list-card {\r\n  flex: 1;\r\n  min-height: 0;\r\n  height: auto;\r\n  margin-bottom: 0;\r\n}\r\n\r\n.deicing-list .item-list-grid-wrapper {\r\n  flex: 1;\r\n  min-height: 0;\r\n  height: auto;\r\n}\r\n\r\n.deicing-list .item-list-actions {\r\n  margin-top: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
